import { Col, Row, Form, Input, Button } from "antd";
import { ImWhatsapp } from "react-icons/im";
import { ImageUrl } from "../../../config/helper";
import { Container } from "postcss";
import { FaArrowRightLong } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";

const onFinish = (values) => {
  console.log("Success:", values);
};
const onFinishFailed = (errorInfo) => {
  console.log("Failed:", errorInfo);
};

const HomeComponent4 = () => {
  const navigate = useNavigate();
  return (
    <>
      <section className="home-about-section1">
        <Row justify={"center"} className="py-10">
          <Col lg={18}>
            <Row justify="center">
              <Col xxl={12} md={12} sm={20} xs={20}>
                <h3 className="font-goldman text-white md:text-[50px] sm:text-[30px] text-[25px]">
                  About Us
                </h3>
              </Col>
              <Col xxl={12} md={12} sm={20} xs={20}>
                <p className="text-[#666666] text-[15px] antialiased">
                  What We Provide Is the Luxury Transport and Most Comfortable
                  Experience Offering luxurious transportation and ensuring the
                  utmost comfort for our clients is our priority. Whether it’s a
                  chauffeured limousine service.
                </p>
              </Col>
            </Row>
          </Col>
        </Row>

        <Row justify={"center"}>
          <Col lg={18}>
            <Row justify="center" gutter={[32, 32]}>
              <Col xxl={16} md={12} sm={20} xs={20} className="">
                <div className="web-card max-w-[500px] h-full p-[30px] ms-auto mr-5 relative">
                  <div className="flex justify-between items-center">
                    <span>
                      <h3 className="font-goldman text-white md:text-[40px]">
                        Luxury Car
                      </h3>
                      <h5 className="font-goldman text-white md:text-[22px]">
                        Chauffeur Service
                      </h5>
                    </span>
                    <span className="web-btn flex w-10 h-10 items-center justify-center cursor-pointer">
                      <FaArrowRightLong />
                    </span>
                  </div>
                  <div className="anim">
                    <img
                      src={ImageUrl("carimg.png")}
                      alt="vector"
                      className=""
                    />
                  </div>
                  {/* <div>
                    <img
                      src={ImageUrl("carimg.png")}
                      alt="vector"
                      className="carpic animate-on-scroll"
                    />
                  </div> */}
                </div>
                
              </Col>
              <Col xxl={8} md={12} sm={20} xs={20}>
                <div className="web-card2">
                  <p className="text-[#c8c8c8]">
                    Our vehicles are meticulously maintained, our staff is
                    highly trained, and our services are tailored to exceed
                    expectations. From the moment you book with us until you
                    reach your destination, expect nothing less than a seamless,
                    indulgent journey.
                  </p>
                  <button
                    className="web-btn py-3 xl:px-12 px-3 text-sm max-xl:text-xs my-4 max-lg:hidden"
                    onClick={() => navigate("/about")}
                  >
                    Discover More
                  </button>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </section>
    </>
  );
};

export default HomeComponent4;
